import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook} from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

// Function
function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>About Us</h3>
          <p>We are dedicated to helping you achieve your fitness goals with top-notch equipment and expert trainers.</p>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/classes">Our Classes</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Contact Info</h3>
          <a 
            href="https://www.google.com/maps/dir//Spartans+Gym,+opposite+Mangwal,+Sangrur,+Punjab+148001/@30.2518439,75.7764854,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x391051c93859b2cb:0x4265e02d130a300e!2m2!1d75.8588966!2d30.2518561?entry=ttu&g_ep=EgoyMDI1MDEyMC4wIKXMDSoASAFQAw%3D%3D" 
            target="_blank" 
            rel="noopener noreferrer"
            className="address-link"
            onClick={(e) => {
              e.preventDefault()
              window.open(e.target.href, '_blank')
            }}
          >
            Spartans Gym, opposite Mangwal, Sangrur, Punjab 148001
          </a>
          <p>Phone: (+91) 83604 83151</p>
          <p>Email: Spartan@gmail.com</p>
        </div>

        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/spartans.official/" className="social-icon" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            
            <a href="https://www.instagram.com/meharbaanspartans?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" className="social-icon" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
          
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 Gym Website. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
